import RangeSlider from "react-range-slider-input";
import {RangeFilterInterface} from "../../interfaces/core/RangeFilterInterface";
import {useEffect, useState, useRef} from "react";

export const RANGE_DELIMITER = '^^^';

export default function Range({name, range, setValue, postfix, currentValue}: {name: string, range: RangeFilterInterface, setValue: (value: any) => void,  postfix?: string, currentValue?: RangeFilterInterface}) {

    const [localRange, setLocalRange] = useState<RangeFilterInterface>(currentValue || range);
    const [inputValues, setInputValues] = useState({
        min: (currentValue?.min || range.min).toString(),
        max: (currentValue?.max || range.max).toString()
    });
    const [key, setKey] = useState(0);
    const sliderTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (currentValue && (currentValue.min !== localRange.min || currentValue.max !== localRange.max)) {
            setLocalRange(currentValue);
            setInputValues({
                min: currentValue.min.toString(),
                max: currentValue.max.toString()
            });
            setKey(prev => prev + 1);
        }
    }, [currentValue]);


    const handleInputChange = (value: string, isMin: boolean) => {
        // Оставляем только цифры
        const numericValue = value.replace(/[^\d]/g, '');

        if (isMin) {
            setInputValues({
                ...inputValues,
                min: numericValue
            });
        } else {
            setInputValues({
                ...inputValues,
                max: numericValue
            });
        }
    };

    const handleBlur = (isMin: boolean) => {
        const value = isMin ? inputValues.min : inputValues.max;
        const parsedValue = value === '' ? (isMin ? range.min : range.max) : parseInt(value, 10);

        // Ограничиваем значение диапазоном
        let clampedValue = Math.max(range.min, Math.min(range.max, parsedValue));

        let newRange: RangeFilterInterface;
        if (isMin) {
            // Минимум не может быть больше текущего максимума
            clampedValue = Math.min(clampedValue, localRange.max);
            newRange = {
                min: clampedValue,
                max: localRange.max
            };
            setLocalRange(newRange);
            setInputValues({
                ...inputValues,
                min: clampedValue.toString()
            });
        } else {
            // Максимум не может быть меньше текущего минимума
            clampedValue = Math.max(clampedValue, localRange.min);
            newRange = {
                min: localRange.min,
                max: clampedValue
            };
            setLocalRange(newRange);
            setInputValues({
                ...inputValues,
                max: clampedValue.toString()
            });
        }

        // Принудительно обновляем слайдер
        setKey(prev => prev + 1);

        // Вызываем setValue для обновления родительского компонента
        setValue(newRange);
    };

    return (<div className="d-flex flex-column filter__box">
        <div className="filter__t-big fw-medium pb-3">{name}</div>
        <div className="range">
            <div className="row">
                <div className="col-6">
                    <div className="input-group mb-3">
                        <span className="input-group-text">от</span>
                        <input
                            type="text"
                            className="form-control"
                            value={inputValues.min}
                            onChange={(e) => handleInputChange(e.target.value, true)}
                            onBlur={() => handleBlur(true)}
                        />
                        {postfix && <span className="input-group-text">{postfix}</span>}
                    </div>
                </div>
                <div className="col-6">
                    <div className="input-group mb-3">
                        <span className="input-group-text">до</span>
                        <input
                            type="text"
                            className="form-control "
                            value={inputValues.max}
                            onChange={(e) => handleInputChange(e.target.value, false)}
                            onBlur={() => handleBlur(false)}
                        />
                        {postfix && <span className="input-group-text">{postfix}</span>}
                    </div>
                </div>
            </div>
            {localRange.max && <RangeSlider
                key={key}
                min={range.min}
                max={range.max}
                defaultValue={[localRange.min, localRange.max]}
                onInput={(val) => {
                    const newRange = {
                        min: val[0],
                        max: val[1]
                    };
                    setLocalRange(newRange);
                    setInputValues({
                        min: val[0].toString(),
                        max: val[1].toString()
                    });

                    // Debounce: вызываем setValue с задержкой
                    if (sliderTimeoutRef.current) {
                        clearTimeout(sliderTimeoutRef.current);
                    }
                    sliderTimeoutRef.current = setTimeout(() => {
                        setValue(newRange);
                    }, 500);
                }}
            />}

        </div>
    </div>)
}